module.exports = __webpack_public_path__ + "img/daytime-results-2.3f7433e6.png";